/* EASTEAM Return Tiers (draft).
   One return option per order, saved as cart attribute "return_tier":
   final_sale (default) / standard / protected.
   - Product page: a one-line "Returns" row above the quantity box; "Change"
     opens a pop-up with the three options. "Checkout now" (handled inline in
     snippets/return-tiers-pdp.liquid) goes straight to checkout carrying it.
   - Cart drawer: a reminder of the chosen option under the total, with "Change".
   - Cart page: the full three-option list (snippets/return-tier-selector).
   - Quick view pop-up: the same "Returns" row above its buttons. Its
     "Checkout" button is taken over here (assets/ea-quickview.js is not
     edited): we press its own "Add to Bag", wait for "In your bag", apply the
     return option, then go to checkout through gift-auto's free-gift check.
   Config (Final Sale code, Return Protection variant) lives in ONE place,
   snippets/return-tiers-config.liquid, as window.EA_RT. While blank, only the
   choice is saved. */
(function () {
  if (window.__easteamReturnTiers) return;
  window.__easteamReturnTiers = true;

  var TIERS = {
    final_sale: {
      name: 'Final Sale', price: '−15%', badge: 'Best price · Save 15%',
      desc: '<b>15% off this order.</b> No returns or exchanges for fit or style. Damaged, defective or wrong items are always covered. Can\'t be combined with other discounts.',
      row: '<b>Final Sale</b> <span class="rt-pill">−15%</span> · no returns for fit or style',
      remind: '<b>Final Sale:</b> 15% off. No returns or exchanges for fit or style.'
    },
    standard: {
      name: 'Standard', price: 'Included',
      desc: 'Free exchanges and store credit. Refunds to your card carry a $25 restocking fee. Works with first-order offers like WELCOME10.',
      row: '<b>Standard</b> · free exchanges &amp; store credit',
      remind: '<b>Standard returns:</b> free exchanges &amp; store credit; $25 fee on card refunds.'
    },
    protected: {
      name: 'Return Protection', price: '+ $10', tag: 'US orders',
      desc: 'Changed your mind? Send it back free for a full refund, no questions asked. We email you a prepaid return label, and there\'s no restocking fee.',
      row: '<b>Return Protection</b> <span class="rt-pill">+$10</span> · free returns, full refund',
      remind: '<b>Return Protection:</b> free return label and a full refund if you change your mind.'
    }
  };
  var SUMMARY = {
    final_sale: 'Final Sale: 15% off. Can\'t be combined with other discounts. No returns for fit or style.',
    standard: 'Standard: free exchanges and store credit, works with your welcome offer. $25 restocking fee on card refunds.',
    protected: 'Return Protection: free return label and full refund, no restocking fee.'
  };

  function roots() { return Array.prototype.slice.call(document.querySelectorAll('[data-rt]')); }
  function cfg() {
    var g = window.EA_RT || {}, r = roots()[0];
    return {
      us: r ? r.dataset.rtUs === 'true' : g.us !== false,
      variant: g.variant || '',
      code: g.code || '',
      policy: g.policy || '/policies/refund-policy'
    };
  }
  var current = (function () {
    var r = roots()[0];
    return (r && r.dataset.rtTier) || (window.EA_RT && window.EA_RT.tier) || 'final_sale';
  })();

  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error(url + ' ' + r.status); return r.json(); });
  }
  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }

  function paint(tier, msg) {
    current = tier;
    roots().forEach(function (root) {
      root.dataset.rtTier = tier;
      root.querySelectorAll('[data-rt-option]').forEach(function (b) {
        b.setAttribute('aria-checked', b.dataset.rtOption === tier ? 'true' : 'false');
      });
      var s = root.querySelector('[data-rt-summary]'); if (s) s.textContent = SUMMARY[tier] || '';
      var st = root.querySelector('[data-rt-status]'); if (st) st.textContent = msg || '';
    });
    var t = TIERS[tier] || TIERS.final_sale;
    document.querySelectorAll('[data-rt-row-text]').forEach(function (el) { el.innerHTML = t.row; });
    document.querySelectorAll('[data-rt-remind]').forEach(function (el) {
      el.className = 'rt-remind rt-remind--' + tier;
      var x = el.querySelector('[data-rt-remind-text]'); if (x) x.innerHTML = t.remind;
    });
    document.querySelectorAll('[data-rt-sheet-opt]').forEach(function (b) {
      b.setAttribute('aria-checked', b.dataset.rtSheetOpt === tier ? 'true' : 'false');
    });
  }
  function cookieCode() {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    return m ? decodeURIComponent(m[1]) : '';
  }
  function uniq(list) {
    var seen = {};
    return list.filter(function (x) { var k = x.toUpperCase(); if (!x || seen[k]) return false; seen[k] = 1; return true; });
  }
  function busy(on) { roots().forEach(function (r) { r.classList.toggle('is-busy', on); }); }

  /* Save the tier and make the cart match it (Return Protection line, Final
     Sale code). Resolves to true when the cart contents/discounts changed. */
  function sync(tier) {
    var c = cfg(), changed = false, msg = '';
    if (tier === 'protected' && !c.us) tier = 'final_sale';
    return post('/cart/update.js', { attributes: { return_tier: tier } })
      .then(function () { return (c.variant || c.code) ? getCart() : null; })
      .then(function (cart) {
        if (!cart) return;
        var steps = Promise.resolve();
        if (c.variant) {
          var line = cart.items.filter(function (i) { return String(i.variant_id) === String(c.variant); })[0];
          var others = cart.items.filter(function (i) { return String(i.variant_id) !== String(c.variant); }).length;
          if (tier === 'protected' && !line && others) {
            changed = true; steps = steps.then(function () { return post('/cart/add.js', { items: [{ id: Number(c.variant), quantity: 1 }] }); });
          } else if (tier === 'protected' && line && line.quantity !== 1) {
            changed = true; steps = steps.then(function () { return post('/cart/change.js', { id: line.key, quantity: 1 }); });
          } else if ((tier !== 'protected' || !others) && line) {
            changed = true; steps = steps.then(function () { return post('/cart/change.js', { id: line.key, quantity: 0 }); });
          }
        }
        if (c.code) {
          /* Final Sale can't be combined with any other code. While it's on, other
             codes (e.g. WELCOME10 from an email link) are set aside in a hidden cart
             attribute; choosing Standard or Protection re-applies them. */
          var FS = c.code.toUpperCase();
          var codes = (cart.discount_codes || []).map(function (d) { return d.code; });
          var rest = codes.filter(function (x) { return x.toUpperCase() !== FS; });
          var has = codes.length !== rest.length;
          var saved = ((cart.attributes || {})._rt_prev_codes || '').split(',').filter(Boolean);
          var pending = cookieCode();
          var inCart = codes.some(function (x) { return x.toUpperCase() === pending.toUpperCase(); });
          if (pending && pending.toUpperCase() !== FS && !inCart) saved.push(pending);
          var keep = uniq(rest.concat(saved));
          if (tier === 'final_sale' && (!has || rest.length)) {
            changed = true;
            if (keep.length) msg = 'Final Sale can\'t be combined with other discounts, so ' + keep.join(', ') + ' is set aside. Choose Standard to use it.';
            try { document.cookie = 'discount_code=; Max-Age=0; path=/'; } catch (e) {}
            steps = steps.then(function () { return post('/cart/update.js', { discount: c.code, attributes: { _rt_prev_codes: keep.join(',') } }); });
          } else if (tier !== 'final_sale' && (has || saved.length)) {
            changed = true;
            if (keep.length) msg = keep.join(', ') + ' is applied.';
            steps = steps.then(function () { return post('/cart/update.js', { discount: keep.join(','), attributes: { _rt_prev_codes: '' } }); });
          }
        }
        return steps;
      })
      .then(function () { return { changed: changed, msg: msg, tier: tier }; });
  }

  function setTier(tier, quiet) {
    var c = cfg();
    if (tier === 'protected' && !c.us) tier = 'final_sale';
    paint(tier);
    if (!quiet) busy(true);
    return sync(tier)
      .then(function (res) {
        if (!res.changed) return;
        try { if (res.msg) sessionStorage.setItem('rt_msg', res.msg); } catch (e) {}
        window.location.reload();
      })
      .catch(function (e) {
        console.warn('[return-tiers]', e);
        paint(tier, 'Something went wrong saving your return option. Please try again.');
      })
      .then(function () { busy(false); });
  }

  /* ---------- pop-up with the three options ---------- */
  var sheet = null;
  function buildSheet() {
    var c = cfg();
    var el = document.createElement('div');
    el.className = 'rt-sheet'; el.hidden = true;
    el.setAttribute('data-rt-sheet', '');
    var opts = ['final_sale', 'standard', 'protected'].map(function (k) {
      var t = TIERS[k], off = (k === 'protected' && !c.us);
      return '<button type="button" class="rt-sopt' + (k === 'final_sale' ? ' rt-sopt--featured' : '') + '" role="radio" aria-checked="false" data-rt-sheet-opt="' + k + '"' + (off ? ' disabled' : '') + '>' +
        '<span class="rt-sopt__radio" aria-hidden="true"></span>' +
        '<span class="rt-sopt__body"><span class="rt-sopt__name">' + t.name +
        (t.badge ? ' <span class="rt-sopt__badge">' + t.badge + '</span>' : '') +
        (t.tag ? ' <span class="rt-sopt__tag">' + t.tag + '</span>' : '') + '</span>' +
        '<span class="rt-sopt__desc">' + t.desc + '</span>' +
        (off ? '<span class="rt-sopt__lock">US orders only. We can\'t send prepaid return labels abroad.</span>' : '') +
        '</span><span class="rt-sopt__price">' + t.price + '</span></button>';
    }).join('');
    el.innerHTML = '<div class="rt-sheet__panel" role="dialog" aria-modal="true" aria-label="Choose your return option">' +
      '<div class="rt-sheet__head"><span>Choose your return option</span><button type="button" class="rt-sheet__x" data-rt-close aria-label="Close">×</button></div>' +
      '<div class="rt-sheet__opts" role="radiogroup" aria-label="Return option">' + opts + '</div>' +
      '<p class="rt-sheet__fine">Full terms in our <a href="' + c.policy + '">Return &amp; Refund Policy</a>.</p>' +
      '<button type="button" class="rt-sheet__done" data-rt-close>Done</button></div>';
    document.body.appendChild(el);
    return el;
  }
  function openSheet() {
    if (!sheet) sheet = buildSheet();
    paint(current);
    sheet.hidden = false;
    document.documentElement.classList.add('rt-lock');
    var on = sheet.querySelector('[aria-checked="true"]') || sheet.querySelector('[data-rt-sheet-opt]');
    if (on) on.focus();
  }
  function closeSheet() {
    if (!sheet || sheet.hidden) return;
    sheet.hidden = true;
    document.documentElement.classList.remove('rt-lock');
  }

  /* ---------- "Returns" row: product page + quick view ---------- */
  function makeRow() {
    var row = document.createElement('button');
    row.type = 'button';
    row.className = 'rt-row';
    row.setAttribute('data-rt-row', '');
    row.setAttribute('data-rt-open', '');
    row.setAttribute('aria-haspopup', 'dialog');
    row.innerHTML = '<span><span class="rt-row__k">Returns</span><span class="rt-row__v" data-rt-row-text></span></span><span class="rt-row__chg">Change</span>';
    return row;
  }
  function mountRow() {
    var added = false;
    /* product page: above the quantity box */
    if (window.EA_RT && window.EA_RT.pdp) {
      var pdp = document.querySelector('.ea-pdp');
      var anchor = pdp && !pdp.querySelector('[data-rt-row]') && pdp.querySelector('.ea-express');
      if (anchor) { anchor.parentNode.insertBefore(makeRow(), anchor); added = true; }
    }
    /* quick view pop-up: above its Checkout / Add to Bag buttons */
    document.querySelectorAll('[data-eaqv]').forEach(function (qv) {
      if (qv.querySelector('[data-rt-row]')) return;
      var btn = qv.querySelector('[data-eaqv-checkout]');
      if (!btn) return;
      var group = btn.parentNode;
      group.parentNode.insertBefore(makeRow(), group);
      added = true;
    });
    if (added) paint(current);
  }

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var open = t.closest('[data-rt-open]');
    if (open) { e.preventDefault(); openSheet(); return; }
    if (t.closest('[data-rt-close]')) { e.preventDefault(); closeSheet(); return; }
    if (sheet && t === sheet) { closeSheet(); return; }
    var so = t.closest('[data-rt-sheet-opt]');
    if (so) { e.preventDefault(); if (!so.disabled) setTier(so.dataset.rtSheetOpt); return; }
    var b = t.closest('[data-rt-option]');
    if (b && !b.disabled) { e.preventDefault(); setTier(b.dataset.rtOption); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeSheet(); return; }
    var b = e.target.closest && e.target.closest('[data-rt-option], [data-rt-sheet-opt]');
    if (!b) return;
    var keys = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 };
    if (!keys[e.key]) return;
    var opts = Array.prototype.slice.call(b.parentNode.querySelectorAll('[data-rt-option]:not([disabled]), [data-rt-sheet-opt]:not([disabled])'));
    var i = (opts.indexOf(b) + keys[e.key] + opts.length) % opts.length;
    e.preventDefault(); opts[i].focus();
    setTier(opts[i].dataset.rtOption || opts[i].dataset.rtSheetOpt);
  });

  /* ---------- quick view "Checkout" ---------- */
  function goCheckout() {
    /* hand over to gift-auto: it reconciles the free gift, then opens /checkout */
    var a = document.createElement('a');
    a.href = '/checkout';
    a.setAttribute('data-checkout-button', '');
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    setTimeout(function () { if (location.pathname.indexOf('/checkout') !== 0) location.href = '/checkout'; }, 8000);
  }
  window.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-eaqv-checkout]');
    if (!b || b.disabled) return;
    var qv = b.closest('[data-eaqv]');
    var atc = qv && qv.querySelector('[data-eaqv-atc]');
    if (!atc || atc.disabled) return;              /* nothing to hook: leave the original behaviour */
    e.preventDefault();
    e.stopImmediatePropagation();                   /* the quick view's own Checkout handler never runs */
    if (b.__rtBusy) return;
    b.__rtBusy = true;
    b.setAttribute('aria-busy', 'true');
    var done = false, obs = null;
    function finish() {
      if (done) return;
      done = true;
      if (obs) obs.disconnect();
      window.__eaCheckingOut = true;
      sync(current).catch(function () {}).then(goCheckout);
    }
    try {
      obs = new MutationObserver(function () { if (atc.classList.contains('added')) finish(); });
      obs.observe(atc, { attributes: true, attributeFilter: ['class'] });
    } catch (err) {}
    setTimeout(function () { if (!done) { done = true; if (obs) obs.disconnect(); location.href = '/cart'; } }, 8000);
    atc.click();                                    /* the quick view adds the piece its own way */
  }, true);

  /* used by the product page "Checkout now" handler */
  window.EasteamReturnTiers = {
    tier: function () { return current; },
    sync: function () { return sync(current); },
    open: openSheet
  };

  function init() {
    mountRow();
    /* colour swaps replace the product page in place, and the quick view
       pop-up is filled on demand: re-add the row whenever either changes */
    try {
      var tm;
      var again = function () { clearTimeout(tm); tm = setTimeout(mountRow, 60); };
      if (window.EA_RT && window.EA_RT.pdp) {
        new MutationObserver(again).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
      }
      var qvHost = function () { return document.querySelector('.quickview-popup .popup-body-inner'); };
      var watchQv = function () {
        var h = qvHost(); if (!h) return false;
        new MutationObserver(again).observe(h, { childList: true, subtree: true });
        return true;
      };
      if (!watchQv()) { var n = 0, iv = setInterval(function () { if (watchQv() || ++n > 40) clearInterval(iv); }, 250); }
    } catch (e) {}
    var note = '';
    try { note = sessionStorage.getItem('rt_msg') || ''; sessionStorage.removeItem('rt_msg'); } catch (e) {}
    paint(current, note);
    var r = roots()[0];
    /* Final Sale is pre-selected: save it once the bag has items */
    if (r && r.dataset.rtItems !== '0' && r.dataset.rtSavedTier !== r.dataset.rtTier) setTier(r.dataset.rtTier, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
